import { Injectable } from '@angular/core';
import { ContextFactory } from '@shared/factories/context/context.factory';
import * as mixpanel from 'mixpanel-browser';

@Injectable({
  providedIn: 'root'
})
export class RegisterMixtapeService {

  constructor(private context: ContextFactory){

  }
  isLanding: any = location.pathname.indexOf('public/') !== -1 || location.pathname.indexOf('shared/') !== -1 || location.pathname.indexOf('contact-login') !== -1;
  init(): void {
    if ((window.location.href.indexOf('localhost') === -1) && !this.isLanding) {
      try {
          mixpanel.init(window.location.href.indexOf('affin') !== -1 || window.location.href.indexOf('centinelappd') !== -1 ? "4a9be5e776aeb1513401ee768d7a5eb4" : "ac2de1661c0bed65d35b808785d452b1");
      } catch (err) {
          console.error(err)
      }
    }
  }

  register(event:any){
    if(window.location.href.indexOf('localhost') === -1 && !this.isLanding){
      mixpanel.track(event.event, this.configureEvent(event));
    }
  }

  configureEvent(event:any){
    return {
      'Distinct ID': this.context.user.externalId,
      'Client ID': event.clientId || this.context.user.companyExternalId,
      'Event': event.event,
      'Centinela product': event.centinelaProduct || this.context.settings.defaultProduct,
      'Concept name': event.conceptName || null,
      'Task type': event.taskType || null,
      'Repeat task': event.repeatTask || null,
      'Source': event.source || null,
      'Report type': event.reportType || null,
      'Alert type':event.alertType || null,
      "Step name": event.stepName || null,
      'Process name': event.processName || null,
      'Template': event.template || null,
      'Legal Doc Title': event.legalDocTitle || null,
      'Legal Doc Type': event.legalDocType || null,
      'Option select': event.optionSelect || null

    }
  }

}

